import { render, staticRenderFns } from "./ActivitySelectForm.vue?vue&type=template&id=2bd13345"
import script from "./ActivitySelectForm.vue?vue&type=script&lang=js"
export * from "./ActivitySelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports